import { Theme } from '@material-ui/core/styles';

const WAMuiChipInput = (theme: Theme): unknown => ({
    chip: {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[500],
        borderRadius: 3,
        margin: '0 3px',
        '& > svg': {
            color: theme.palette.grey[500],
        },
    },

    inputRoot: {
        minHeight: 48,
        '&[class*="MuiOutlinedInput-root"]': {
            padding: 8,
            '&[class*="MuiOutlinedInput-marginDense"]': {
                minHeight: 32,
                padding: 2,
            },
        },
        '&[class*="MuiOutlinedInput-marginDense"] $chip': {
            height: 24,
        },
    },

    label: {
        '&$outlined&:not($labelShrink)': {
            top: 0,
            '$marginDense &': {
                top: 0,
            },
        },
    },
    root: {
        '& [class*="MuiFormLabel-root"][class*="MuiInputLabel-outlined"]': {
            '&[class*="MuiInputLabel-shrink"]': {
                transform: 'translate(0px, -16px) scale(0.75)',
                '&[class*="MuiInputLabel-marginDense"]': {
                    transform: 'translate(0px, -16px) scale(0.75)',
                },
            },
            '&:not(.MuiInputLabel-shrink)': {
                top: 0,
            },
        },

        '& legend': {
            display: 'none',
        },

        '& fieldset': {
            top: 0,
        },

        '& $inputRoot[class*="MuiOutlinedInput-root"] $input': {
            marginTop: 0,
            marginBottom: 0,
            padding: '6.5px 4px',
        },

        '&$marginDense': {
            '& $chipContainer': {
                minHeight: 32,
            },
        },
    },
});

export default WAMuiChipInput;
